import EFVideoModal, { PlayerType } from '@/components/UI/EFVideoModal';
import Image from '@/components/UI/Image';
import { getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { ReactNode } from 'react';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/deltapro/h5/');
const { EFPic: EFPic2 } = createEFPic('');
export default function Bannervideo({ icon = '/icons/video_play_white.svg' }: any) {
    const { useRouter, useState, useLang, gtm } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['uk', 'au', 'jp', 'cn', 'de', 'fr', 'es', 'it', 'eu', 'za', 'cis']);

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/ozVzv0jo_BM',
        cn: {
            SD: 'https://videos.ecoflow.com/b496757dbe684c2292ad06a2069744e3/90da871a433f4f6d92112b761edc0320-6a9f4ffe2304e35bdffa8bb730756a0f-fd.mp4',
            HD: 'https://videos.ecoflow.com/b496757dbe684c2292ad06a2069744e3/90da871a433f4f6d92112b761edc0320-f9f11f7878eb13eb490a81b52ec658c9-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/41625e27-182edc0094a-0004-9c91-e6d-40030.mp4',
        },
        cis: 'https://www.youtube.com/embed/CbWu9D8uivE',
    };

    const playerVideo = (position: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA Pro',
            position,
            __btn_id1: css.bannervideo,
            __btn_id2: t('watch_video'),
        });
        setShowEFVideoModal(true);
    };

    return (
        <div className={`${css.bannervideo} bannervideo GtmModuleData-section`} data-section-id={css.bannervideo} data-section-title={t('ecoflow_delta_pro')}>
            <div className="bannerBox page-video">
                <div className="videxBox">
                    {locale === 'ph' ? (
                        <img src="https://websiteoss.ecoflow.com/upload/image/1751272855312/kv-h5.jpg" className="fullImgs" alt={t('DELTA Pro')} />
                    ) : (
                        <EFPic name={[`banner_${imgSpec}.webp`, `banner_${imgSpec}.jpg`]} className="fullImgs" alt={t('DELTA Pro')} />
                    )}
                </div>
                <div className="bannerText">
                    <div className="bannerMsg1">{t('ecoflow_delta_pro')}</div>
                    <div className="bannerImg1">
                        <div className="radial-text">
                            {t.rich('bannner_desc_h5', {
                                line1: (child: ReactNode) => <div>{child} </div>,
                                line2: (child: ReactNode) => <div>{child} </div>,
                            })}
                        </div>
                    </div>
                    <div className="videoButton GtmModuleData-btn-text" onClick={() => playerVideo('Product Detail_1')}>
                        <span className="btnText font-family-medium">{t('watch_video')}</span>
                        <span className="btn-icon">
                            <Image src={icon} layout="fill" className="fullImgs" alt={t('watch_video')} />
                        </span>
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? PlayerType.Alibaba : PlayerType.YouTube}
            />
        </div>
    );
}
